import React, {useState} from 'react'
import {useParams} from "react-router";
import {makeStyles} from "@material-ui/styles";
import GridBlock from "components/GridBlock";
import Typography from "components/Typography";
import SimpleSelect from "components/SimpleSelect";
import Tr from "translations/Translations";
import WorkableButton from "components/button/WorkableButton";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import PropTypes from "prop-types";
import clsx from "clsx";
import OfferEspdExternalUploadFile from "./OfferEspdExternalUploadFile";
import TitledComponent from "components/TitledComponent";
import {Link} from "@material-ui/core";

const useStyle = makeStyles(theme => ({
    root: {},
    hidden: {
        display: "none"
    },
    select: {
        width: 400,
        marginBottom: theme.spacing(2),
    },
    menuItemClassName: {
        whiteSpace: 'normal'
    },
    column: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        flexBasis: '100%',
        padding: theme.spacing(2)
    },
    button: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(2),
    }
}))

function OfferEspdExternal(
    {
        offerEdit,
        disabled,
        positionItems,
        visible
    }) {
    const classes = useStyle();
    const params = useParams();
    const [positionId, setPositionId] = useState("");
    const [error, setError] = useState();
    const [working, setWorking] = useState(false);


    const downloadEspd = () => {
        if (offerEdit.espdOnPositions && positionId === "") {
            setError(Tr("choose_position"))
            return
        }
        setWorking(true);
        DemandOffersOfferService.downloadContractorESPDExportFile(params.id, params.stageId, positionId).finally(() => setWorking(false));
    }

    return (<GridBlock
            className={clsx({[classes.hidden]: !visible})}
            wrap='nowrap'
            itemClassName={classes.column}
        >
            <div>
                <Typography>{Tr('offer_espd_type_external_help')}</Typography>
                <Typography>{Tr('offer_espd_type_external_help2')}
                    <Link target="_blank" href="https://espd.uzp.gov.pl/filter?lang=pl">https://espd.uzp.gov.pl/filter?lang=pl</Link>
                </Typography>

            </div>
            <div>
                <TitledComponent
                    title={Tr('espd_external_step_1')}
                >
                    <GridBlock>
                    {
                        offerEdit.espdOnPositions &&
                        <SimpleSelect
                            label={Tr('choose_position')}
                            className={classes.select}
                            menuItemClassName={classes.menuItemClassName}
                            items={positionItems}
                            value={positionId}
                            onChange={(e) => {
                                setError()
                                setPositionId(e.target.value)
                            }}
                            error={error}
                            disabled={disabled || working}
                        />
                    }
                    <WorkableButton className={classes.button} disabled={disabled} working={working} onClick={downloadEspd}>{Tr("download")}</WorkableButton>
                    </GridBlock>
                </TitledComponent>
                <OfferEspdExternalUploadFile disabled={disabled} positionItems={positionItems} dealingId={positionId} offerEdit={offerEdit}/>
            </div>
        </GridBlock>
    )
}

OfferEspdExternal.propTypes = {
    visible: PropTypes.bool.isRequired
};

export default OfferEspdExternal;